import { Button, Input, Row, Space, Col, Form, Popconfirm } from "antd";
import Title from "antd/lib/skeleton/Title";
import axios from "axios";
import React, { useEffect } from "react";
import { createRef } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { H5, H6 } from "../../../../AbstractElements";
import { TermsAndCondtitionsAPI } from "../../../../api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const TermsAndConditions = (props) => {
  const logger = React.useContext(LoggerContext);

  const formRef = createRef();
  const [tc, setTc] = useState();
  const [changes, setChanges] = useState(false);
  const { userDetails, setUserDetails } = useAPIUser();
  useEffect(() => {
    fetchTandCs();
  }, []);

  const fetchTandCs = () => {
    axios.get(`${TermsAndCondtitionsAPI}`).then((res) => {
      setTc(res.data);
    });
  };

  const addTerm = () => {
    logger.log(LogEvents.addnewTermsandConditions, {});
    const updateValues = formRef.current.getFieldsValue();
    const value = new FormData();
    value.append("title", updateValues.title);
    value.append("description", updateValues.description);
    value.append(
      "organisation",
      props.settings?.user?.organisation?.organisation_id
    );
    value.append("status", true);
    axios
      .post(`${TermsAndCondtitionsAPI}`, value)
      .then((res) => {
        toast.success("Added Successfully!");
        formRef.current.resetFields();
        fetchTandCs();
      })
      .catch((res) => {
        toast.error("Something Went Wrong!");
      });
  };

  const deleteTerm = (e, id) => {
    e.preventDefault();
    axios
      .delete(`${TermsAndCondtitionsAPI}${id}/`)
      .then((res) => {
        toast.success("Term deleted successully!");
        fetchTandCs();
      })
      .catch((res) => {
        toast.error("Something went wrong!");
      });
  };

  const onChangeData = (value, name, data) => {
    setChanges(true);
    var array = tc;
    for (var i = 0; i < array?.length; i++) {
      if (array[i]?.id === data?.id) {
        array[i][name] = value;
      }
    }
    setTc(array);
  };

  const saveChanges = (e) => {
    e.preventDefault();
    if (tc?.filter((each) => each?.title === "").length > 0) {
      toast.error("Title Field cannot be empty!");
      return;
    } else {
      var array = tc;
      var j = 0;
      for (var i = 0; i < array?.length; i++) {
        const value = new FormData();
        value.append("title", array[i]?.title);
        value.append("description", array[i]?.description);
        axios
          .put(`${TermsAndCondtitionsAPI}${array[i].id}/`, value)
          .then((res) => {
            j += 1;
            if (j == array?.length) {
              console.log("Changes saved");
              toast.success("Changes Saved!");
              setChanges(false);
            }
          })
          .catch((res) => {
            toast.error("Something Went Wrong!");
          });
      }
    }
  };
  return (
    <React.Fragment>
      <CardBody>
        <div className="d-flex justify-content-between">
          <H5>Existing Terms and Conditions</H5>
          <Button
            disabled={!changes}
            onClick={(e) => {
              saveChanges(e);
            }}
          >
            Save Changes
          </Button>
        </div>

        {tc?.length !== 0 ? (
          <Row gutter={24} className="my-2">
            <Col sm={6}>
              <H6>Title</H6>
            </Col>
            <Col sm={12}>
              <H6>Description</H6>
            </Col>
          </Row>
        ) : null}

        {tc?.map((each) => (
          <Row key={each?.id} gutter={24} className="my-2">
            <Col sm={6}>
              <Input
                name="title"
                defaultValue={each?.title}
                onChange={(e) => {
                  onChangeData(e.target.value, e.target.name, each);
                }}
              />
            </Col>
            <Col sm={12}>
              <Input.TextArea
                name="description"
                defaultValue={each?.description}
                onChange={(e) => {
                  onChangeData(e.target.value, e.target.name, each);
                }}
                autoSize={{
                  minRows: 1,
                  maxRows: 20,
                }}
                placeholder="Description"
              />
            </Col>
            <Col sm={6}>
              <Space>
                <Popconfirm
                  title="Are you sure to delete?"
                  okText="Yes"
                  cancelText="Cancel"
                  onConfirm={(e) => {
                    deleteTerm(e, each?.id);
                  }}
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        ))}
        {/* ADD T&C */}
        <hr className="" />
        <H5>Add New Terms and Conditions</H5>
        <Form className="" ref={formRef} id="tcForm" onFinish={addTerm}>
          <Row gutter={24}>
            <Col sm={6}>
              <Form.Item
                name={"title"}
                rules={[
                  {
                    required: true,
                    message: "Title is required",
                  },
                ]}
              >
                <Input placeholder="Title" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"description"}
                rules={[
                  {
                    required: true,
                    message: "Description is required",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 20,
                  }}
                  placeholder="Description"
                />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Space>
                <Button form="tcForm" htmlType="submit">
                  Add
                </Button>
                <Button form="tcForm" htmlType="reset" danger>
                  Cancel
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
        {/* ADD T&C */}
      </CardBody>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(TermsAndConditions);
